import type { ThemeWithoutTokens } from '../theme.types';

export const selectTokens = (theme: ThemeWithoutTokens) =>
  ({
    selectSimpleOptionPaddingY: theme.space.component.y.s,
    selectSimpleOptionPaddingX: theme.space.component.x.m,
    selectSimpleOptionHoverBackgroundColor: theme.colors.border,
    selectSimpleOptionFocusBackgroundColor: theme.colors.primary.alpha,
    selectSimpleRadioPaddingX: theme.space.component.x.xs,
    selectSimpleCheckboxPaddingX: theme.space.component.x.xs,
  }) as const;
